import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from '../common/analytics';

/**
 * Records a first-party page view on every client-side navigation. Keyed on
 * the pathname only, so same-page query-string replaces (tutorial contents,
 * feature deep links) do not count as new page views.
 */
const RouteTracker = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        analytics.trackPageView(pathname);
    }, [pathname]);

    return null;
};

export default RouteTracker;
